import { useState, useEffect } from 'react';

const AlexaTest = () => {
  const [dumpList,setDumpList] = useState([]);

  const fetchDumpList = async () => {
    const response = await fetch('api/alexatest/GetDumpItems');
    const data = await response.json();
    setDumpList(data || []);
  };

  useEffect(() => { fetchDumpList(); }, []);

  return (
    <div>
      <h2>Test</h2>
      <ul className="list-unstyled" style={{ marginTop: 12, paddingLeft: 0 }}>
        {dumpList.map(item => {
          const liStyle = { marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #eee' };
          return (
            <li key={item.id} style={liStyle}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{item.text}</strong>
                  </div>
                </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AlexaTest;